export enum ToolbarWidthsNext {
	XXL = 768,
	XL = 576,
	L = 460,
	M = 450,
	S = 410,
}
